var pageAnimations = [];
var scrolledTop;
var screenHeight;
var $header;
var $scheduleATour;
var residences = [];
var $galWrapper;
var $galWrapperWidth;
var $slide;
var $slideWidth = 0;
var slidedirection;
var $rightArrow,$leftArrow;
var leftArrow = $('button.left');
var rightArrow = $('button.right');
var $otherModelsLength;
var slideGallery = $('.gallery-slide');
var scrollDirection;
var slideW;
var additionalModels;
var $windowWidth;
var startX,endX;
var resCount;
var $categoryTitle;
var $poiListCount;
var qmiCount,aaCount;
var coll;
var leadInitiated = false; 
var $activeForm;
var scheduleForm = false;
var tourTypeTrack = 'appointment-complete';



$(function(){  
	$header = $('header');
	screenHeight = $(window).height();
	isMobile = checkIsMobile();
      $windowWidth = $(window).width();
      $scheduleATour = $(document).find('div.scheduleATour');

	if ( $('body').hasClass('residences') ) {
		if ( window.location.hash == "#quick-move-in-homes" ) {
			$('input[name=qmi]').prop('checked',true);
		}
		collectResidences();
		filterResidences();
	}

      if ( $('body').hasClass('model') ) {
            var viewPortWidth = $('.view-port').width();
            $galWrapper = $(document).find('.view-port');
            $otherModelsLength = $('.model-listing').not('.off').length;
            $slide = $galWrapper.find('.gallery-slide');
            $galWrapperWidth = $galWrapper.width();
            if($windowWidth < 700) {
                  $(document).find('.model-listing').css('width', viewPortWidth - 15+'px');
            } else if($windowWidth < 900) {
                  $(document).find('.model-listing').css('width', viewPortWidth / 2 - 15+'px');
            } else {
                  $(document).find('.model-listing').css('width', viewPortWidth / 3 - 15+'px');
            }
            slideW = $('.gallery-slide .model-listing').width();
            additionalModels = $('.gallery-slide .model-listing');
            if ($('.model-gallery a.media-container').not('off').length < 5 ) {
                   $('.model-gallery').addClass('short-list');
            }; 
            $slide.find('.model-listing').each(function() {
                  if ( !$(this).hasClass('off') ) {
                      $slideWidth += $(this).width() + parseFloat($(this).css('marginRight'));
                  }			
            });
            additionalModelNav();

      }
      if ( $('body').hasClass('residences') ) {
            var url = window.location.href;
            var lastSlash = url.lastIndexOf('/');
            var urlEnd = url.substring(lastSlash + 1);
            if (urlEnd == 'residences') {
                  modelReveal('hide-some');
            } else {
                  modelReveal('no-hide');
            }
            //siteplanReorder(urlEnd.replace('#',''));

            if(url.indexOf('qmiOnly=true') >= 0) {
                  $("input[name=qmi]").prop( "checked", true )
                  filterResidences();
            } 
            
      }
      if ($('body').hasClass('living-here')) {
            if($windowWidth < 901) {
                  mobilePOIMap('restaurants-and-cafes');
            }
            $categoryTitle = $('.map-wrapper aside ul h5');
      }
      if ($('body').hasClass('amenities')) {
            if($windowWidth < 700) {
                  $('.events a').removeClass('js-mediaSwipe');
            }
      }
      
	collectPageAnimations();
	instantiateListeners();
	renderWebPage();

});

function instantiateListeners() {
	$(document).on('click', '.js-toggleMenu', function(e) {
		e.preventDefault();
		if ( $header.hasClass('toggle-nav') ) {
			$header.removeClass('toggle-nav');
		} else {
			$header.addClass('toggle-nav');
		}
	});

	$(document).on('change', '.js-filter', function(e) {
		filterResidences();
            if($(this).is('#price')) {
                  if($(this).val() != 'all') {  
                        $(this).addClass('no-padding');
                        $(this).siblings('label').html(' ');
                  } else {
                        $(this).removeClass('no-padding');
                        $(this).siblings('label').html('Price Range');
                  }
            }
	});

	$(document).on('change', '.js-filterCheckbox', function(e) {
            if($(this).is('#removeActiveadult')) {
                  $(this).parent().removeClass('is-disabled');
                  $('input[name=activeadult]').prop('checked',false).prop('disabled',false).addClass('is-disabled');
            } else if($(this).is('#activeadult')) {
                  $(this).parent().removeClass('is-disabled');
                  $('input[name=removeActiveadult]').prop('checked',false).prop('disabled',false).parent().addClass('is-disabled');
            }
            filterResidences();
            disableCheckbox();
	});

      $(document).on('change', '#collections', function(e) {
            coll = $(this).val();
		siteplanReorder(coll);
	});
      
	$(document).on('click', '.js-resetFilters', function(e) {
		e.preventDefault();
		$('.js-filter').val('all');
		$('input[name=qmi]').prop('checked',false);
		$('input[name=activeadult]').prop('checked',false);
            $('input[name=removeActiveadult]').prop('checked',false).prop('disabled',false);
		filterResidences();
            modelReveal('hide-some');
	});

	$(document).on('click', '.js-switchFP', function(e) {
		e.preventDefault();
		var idx = $(this).index();
		$('.js-switchFP.on').removeClass('on');
		$('.js-floorplan.on').removeClass('on');
		$(this).addClass('on');
		$('.js-floorplan').eq(idx).addClass('on');
	});

	$(document).on('click', '.js-scrollTo', function(e) {
		e.preventDefault();
		var $target = $('#' + $(this).attr('data-target'));
		if ( $target.length ) {
                  if($windowWidth < 700) {
                        $('body,html').animate({scrollTop: $target.offset().top - 50},600);
                  } else {
                        $('body,html').animate({scrollTop: $target.offset().top},600);
                  }
		}
	});

	window.addEventListener("resize", function () {
	    isMobile = checkIsMobile();
	    screenHeight = $(window).height();
	    $header.removeClass('toggle-nav');
	    renderWebPage();
	});

	$(window).on("scroll", function () {
	    if (window.requestAnimationFrame)
	      window.requestAnimationFrame(renderWebPage);
	    else if (window.msRequestAnimationFrame)
	      window.msRequestAnimationFrame(renderWebPage);
	    else if (window.webkitRequestAnimationFrame)
	      window.webkitRequestAnimationFrame(renderWebPage);
	    else if (window.mozRequestAnimationFrame)
	      window.mozRequestAnimationFrame(renderWebPage);
	    else if (window.oRequestAnimationFrame)
	      window.oRequestAnimationFrame(renderWebPage);
	    else {
	      QueueNewFrame = function () {};
	      scrollInterval = setInterval(function () {
	        renderWebPage();
	      }, 16.7);
	    }
	});
}

function collectResidences() {
	$(document).find('.js-listing').each(function() {
		residences.push({
			domOBJ : 	        $(this),
		      beds :              parseInt($(this).attr('data-beds')),
		      baths :             parseInt($(this).attr('data-baths')),
                  sqft :              parseInt($(this).attr('data-sqft')),
                  story :             parseInt($(this).attr('data-story')),
		      price :             parseInt($(this).attr('data-price')),
		      collection :        $(this).attr('data-collection'),
		      qmi :               ($(this).attr('data-qmi') != "" ) ? true : false,
		      activeadult :       ($(this).attr('data-activeadult') != "" ) ? true : false,
                  removeactiveadult : ($(this).attr('data-activeadult') != "" ) ? true : false
		});
	});
}

function filterResidences() {
	var filteredModels = 0;
	var bedsFilter = $('select[name=beds]').val();
	var bathsFilter = $('select[name=baths]').val();
	var priceFilter = $('select[name=price]').val();
      var sqftFilter = $('select[name=sqft]').val();
      var halfSqft = parseInt(sqftFilter.split(' - ')[1]);
      var storyFilter = $('select[name=stories]').val();
	var collectionFilter = $('select[name=collections]').val();
	var qmiFilter = $('input[name=qmi]').is(':checked');
	var activeAdultFilter = $('input[name=activeadult]').is(':checked');
      var removeActiveAdultFilter = $('input[name=removeActiveadult]').is(':checked');

	bedsFilter = ( bedsFilter != "all" ) ? parseInt(bedsFilter) : bedsFilter;
	bathsFilter = ( bathsFilter != "all" ) ? parseInt(bathsFilter) : bathsFilter;
      storyFilter = ( storyFilter != "all" ) ? parseInt(storyFilter) : storyFilter;

      if ( sqftFilter != "all" ) {
            var halfSqft = sqftFilter.split(' - ');
            halfSqft[0] = parseInt(halfSqft[0]);
		halfSqft[1] = parseInt(halfSqft[1]);
	}

	if ( priceFilter != "all" ) {
		priceFilter = priceFilter.split('-');
		priceFilter[0] = parseInt(priceFilter[0]);
		priceFilter[1] = parseInt(priceFilter[1]);
	}

	for ( var i = 0; i < residences.length; i++ ) {
		var res = residences[i];
		if ( 
			((bedsFilter != "all" && bedsFilter == res.beds) || bedsFilter == "all") && 
                  ((sqftFilter != "all" && res.sqft >= halfSqft[0] && res.sqft <= halfSqft[1] ) || sqftFilter == "all") && 
                  ((storyFilter != "all" && storyFilter == res.story) || storyFilter == "all") && 
			((bathsFilter != "all" && bathsFilter == res.baths) || bathsFilter == "all") && 
			((priceFilter != "all" && res.price >= priceFilter[0] && res.price <= priceFilter[1] ) || priceFilter == "all") && 
			((collectionFilter != "all" && collectionFilter == res.collection) || collectionFilter == "all") &&
			((qmiFilter && res.qmi == true) || !qmiFilter) &&
			((activeAdultFilter && res.activeadult == true) || !activeAdultFilter) &&
                  ((removeActiveAdultFilter && res.removeactiveadult == false) || !removeActiveAdultFilter) 
		) {
			residences[i].domOBJ.removeClass('off');
			filteredModels++;
		} else {
			residences[i].domOBJ.addClass('off');
		}
	}

	if ( filteredModels == residences.length ) {
		$('.js-resetFilters').hide();
	} else {
		$('.js-resetFilters').show();
	}

	$('.js-filterResults').text( filteredModels );

      modelReveal('no-hide');
      disableCheckbox();

}

function sortResidences( sortBy, orderBy ) {
  orderBy = typeof orderBy !== "undefined" ? orderBy : 1;
  var htmls = "";

  $('.models-list').html('');

  residences = residences.sort(function (a, b) {
    if (a[sortBy] > b[sortBy]) return orderBy;
    else if (a[sortBy] < b[sortBy]) return orderBy * -1;
  });

  for (var i = 0; i < residences.length; i++) {
    htmls += '<div class="model-listing">'+residences[i].domOBJ+'</div>';
  }

  $('.models-list').html(htmls);

  // Toggle the sort column buttons
  var $sortButton =  $('.js-sortListings.'+sortBy);
  if ( $sortButton.hasClass('on') && orderBy == 1 ) {
    $sortButton.removeClass('desc').addClass('asc');
  } else if ( $sortButton.hasClass('on') && orderBy == -1 ) {
    $sortButton.removeClass('asc').addClass('desc');
  } else {
     $('.js-sortListings.on').removeClass('asc').removeClass('desc').removeClass('on');
     $sortButton.addClass('on');
     if ( orderBy == -1 ) {
      $sortButton.addClass('desc');
     } else {
      $sortButton.addClass('asc');
     }
  }

  filterResidences();
}

function disableCheckbox() { 
      qmiCount = 0;
      aaCount = 0;
      raaCount = 0;
      $(document).find('.model-listing.js-listing').not('.off').each(function(){
            if ($(this).attr('data-qmi') == 'true') {
                  qmiCount++;
            }
            if ($(this).attr('data-activeadult') == 'true') {
                  aaCount++;
            }
            if ($(this).attr('data-activeadult') == '') {
                  raaCount++;
            }
            if (qmiCount > 0) {
                  $(document).find('.model-filters form fieldset').eq(2).removeClass('is-disabled');
                  $('#qmi').prop('disabled',false);
            } else {
                  $(document).find('.model-filters form fieldset').eq(2).addClass('is-disabled');
                  $('#qmi').prop('disabled',true);
            }
            if(aaCount > 0) {
                  $(document).find('.model-filters form fieldset').eq(1).removeClass('is-disabled');
                  $('#activeadult').prop('disabled',false);
            } else {
                  $(document).find('.model-filters form fieldset').eq(1).addClass('is-disabled');
            }
            if(raaCount > 0) {
                  $(document).find('.model-filters form fieldset').eq(0).removeClass('is-disabled');
                  $('#activeadult').prop('disabled',false);
            } else {
                  $(document).find('.model-filters form fieldset').eq(0).addClass('is-disabled');
            }
      });
}  

// To allow reordering of siteplans when filtering by collections
function siteplanReorder(coll) {
      $('.site-plan-wrapper').removeClass('is-visible').addClass('is-hidden');
      if(coll == 'residences') {
            $('.site-plan-wrapper.'+'all').removeClass('is-hidden');
      }
      $('.site-plan-wrapper.'+coll).addClass('is-visible').removeClass('is-hidden');
}

// show more toggle on residences page
function modelReveal($i) {
      if($i == 'hide-some') {
            var $long = 0;
           $(document).find('.model-listing').not('.off').each(function(){
                   if($(this).index() > 11) {
                         $(this).addClass('hidden');
                         $long++;
                   }
                   if($long > 11) {
                        $(document).find('.js-residenceListings-reveal').removeClass('hide');
                   } else {
                         $(document).find('.js-residenceListings-reveal').addClass('hide');
                   }
            })
      } else {
            $(document).find('.model-listing').removeClass('hidden');
            $(document).find('.js-residenceListings-reveal').addClass('hide');
      }
}

function collectPageAnimations() {
	$(document).find('.js-animate').each(function() {
		pageAnimations.push({
			domItem : $(this),
			offset : $(this).offset().top
		});
	});
}

function renderWebPage() {
	scrolledTop = $(window).scrollTop();
	checkPageAnimations();
}

function checkPageAnimations() {
	if ( pageAnimations.length ) {
		for ( var i = 0; i < pageAnimations.length; i++ ) {
			if ( scrolledTop + screenHeight > pageAnimations[i].offset + 60 ) {
				pageAnimations[i].domItem.addClass('animate');
				pageAnimations.splice(i, 1);
        		i = i - 1;
			}
		}
	}
}

function checkIsMobile() {
  if (window.matchMedia("(max-width: 1100px)").matches) {
    return true;
  } else {
    return false;
  }
}

//removes other home designs arrows if less than 4
function additionalModelNav(){
      $otherModelsLength = $(document).find('.model-listing').not('.off').length;
      if ($otherModelsLength < 4 && $windowWidth > 900 ) { 
            $('.gallery-wrapper').addClass('no-arrows'); 
      } else if ($otherModelsLength < 3 && $windowWidth > 900 ) { 
            $('.gallery-wrapper').addClass('no-arrows'); 
      } else if ($otherModelsLength < 2 && $windowWidth < 700 ) { 
            $('.gallery-wrapper').addClass('no-arrows');
      } else { 
            $('.gallery-wrapper').removeClass('no-arrows'); 
      }
};

$(document).on('click', '.js-modelGallery-reveal', function(){
      $(this).parent('.model-gallery').toggleClass('open');
      $(document).find('.model-gallery a.media-container.off').toggleClass('on');
});

// availability page
var $target;
$(function(){ 
      var $url = $(location).attr('href');
      var $params = $url.split("/");
      $target = $params[$params.length-1];
      $target = $target.replace('#', '');
      if ( $('body').hasClass('availability') ) {
            clickThrough($target);
            if($url.indexOf('/grove') > 0){
                  $(document).find('.view-toggle').find('.collection').removeClass('is-active');
                  $(document).find('.view-toggle').find('.grove').addClass('is-active');
                  $(document).find('.filter-wrapper').addClass('is-disabled'); 
            } else {
                  $(document).find('.view-toggle').find('.collection').addClass('is-active');
                  $(document).find('.view-toggle').find('.grove').removeClass('is-active'); 
                  $(document).find('.filter-wrapper').removeClass('is-disabled');
            }
      }
      removeIfNoAvail();
})
// remove if no available home sites
let removeIfNoAvail = function () {
      $(document).find('.group').each(function () {
           if ($(this).find('a.site-plan-link.qmiEmpty.availEmpty').length === $(this).find('a.site-plan-link').length) {
               $colName = $(this).attr('class').split(' ')[0];
                 $(this).removeClass('on');

                  //removed same from collection filter dropdown
                  $(document).find('.js-filterCols').each(function () {
                        if ($(this).hasClass($colName)) {
                              $(this).addClass('off');
                        }
                  });
            }
      });
}
// neighborhood map grove click from home page
let clickThrough = function ($t) {
      if ($t == 'availability') {
            return;
      } else { 
            $(document).find('.group').removeClass('on'); 
            $(document).find('.group.'+$t).addClass('on');
            $(document).find('.js-filterCols').removeClass('is-active'); 
            $(document).find('.js-filterCols.'+$t).addClass('is-active');
            $(document).find('.js-all span').addClass('not-all');
      }
      removeIfNoAvail();
}

$(document).on('click','.site-plan-link', function(){
      $(document).find('.filter-dropdown').removeClass('is-active');
})
$(document).on('click', '.js-viewToggle', function(){
      $target = $(this).attr('data-target');
      $(this).parent('.view-toggle').find('button').removeClass('is-active');
      $(this).addClass('is-active');
      $(this).parent('.view-toggle').siblings('.group').removeClass('on');
      $(this).parent('.view-toggle').siblings('.'+$target).addClass('on');
      $(document).find('.filter-dropdown').removeClass('is-active'); 
      $(document).find('.filter-dropdown span').addClass('is-active');
      if ($target == 'grove') {
            $(document).find('.filter-wrapper').addClass('is-disabled');
      } else {
            $(document).find('.not-all').removeClass('not-all');
            $(document).find('.filter-wrapper').removeClass('is-disabled');
      }
      removeIfNoAvail();
});
$(document).on('click', '.js-filterCols', function(){
      $(this).addClass('is-active');
      $(this).siblings('span').removeClass('is-active');
      $(this).parent().removeClass('is-active');
      $target = $(this).attr('data-target').toLowerCase();
      $(this).parent('.filter-dropdown').parent('.filter-wrapper').siblings('.group').removeClass('on');
      $(this).parent('.filter-dropdown').parent('.filter-wrapper').siblings('.'+$target).addClass('on');
      $(this).siblings('.all').find('span').addClass('not-all');
      removeIfNoAvail();
});
$(document).on('click', '.js-all', function() {
      $(this).siblings('span').addClass('is-active');
      $(this).parent().removeClass('is-active');
      $(this).parent('.filter-dropdown').parent('.filter-wrapper').siblings('.collection').addClass('on'); 
      $(document).find('.not-all').removeClass('not-all');
      removeIfNoAvail();
});
$(document).on('click', '.filter-wrapper button', function() {
      $(this).siblings('.filter-dropdown').toggleClass('is-active'); 
      
});
$(document).on('click', '.js-filterGroves', function(){
      $(document).find('.view-toggle').find('.collection').removeClass('is-active');
      $(document).find('.view-toggle').find('.grove').addClass('is-active');
      $(document).find('.filter-wrapper').addClass('is-disabled');
      $target = $(this).attr('data-target');
      $(document).find('.content-wrapper .group').removeClass('on');
      $(document).find('.'+$target).addClass('on');
      $([document.documentElement, document.body]).animate({
          scrollTop: $(".content-wrapper").offset().top 
      }, 200);
      $(document).find('.filter-dropdown').removeClass('is-active');
      $(document).find('.filter-dropdown span').removeClass('is-active');
});

$(document).on('click', '.js-residenceListings-reveal', function(){
      $(this).parent('.model-listings').toggleClass('open');
      $(document).find('.model-gallery a.media-container.off').toggleClass('on');
});

$(document).on('click', '.model-gallery.open .js-modelGallery-reveal', function(){
      $('html, body').animate({
            scrollTop: $('.model-gallery').offset().top
        }, 300);
});

$(document).on('click', '.model-listings.open .js-residenceListings-reveal', function(){
      $('html, body').animate({
            scrollTop: $('.model-listings').offset().top
        }, 300);
});

$(document).on('click', '.js-slideGallery', function(e) {
      e.preventDefault();
      if ($galWrapper.hasClass('sliding')) return false;
      $galWrapper.addClass('sliding');
      $slideWidth = 0;
      $slide.find('.model-listing').each(function() {
            if ( !$(this).hasClass('off') ) {
                $slideWidth += $(this).width() + parseFloat($(this).css('marginRight'));
            }			
      });
      slideDirection = ($(this).hasClass('left')) ? 1 : -1;
      startX = parseFloat($slide.css('marginLeft'));
      endX = startX + $galWrapperWidth * slideDirection;

      if ( endX > 0 ) {
            endX = 0;
      } else if ( endX < $galWrapperWidth - $slideWidth ) {
            endX = $galWrapperWidth - $slideWidth;
      }
      
      if($(this).hasClass('left')){
            rightArrow.removeClass('disabled');
            if ( startX > -500 ) {
                  leftArrow.addClass('disabled');
            }
      } else if($(this).hasClass('right')){
            leftArrow.removeClass('disabled');
            
            if ($otherModelsLength > 6) {
                  if (startX < ('-'+($slideWidth - $galWrapperWidth - $windowWidth))) {
                        rightArrow.addClass('disabled');
                  }
            } else {
                  if ($galWrapperWidth > $slideWidth/2) {
                        rightArrow.addClass('disabled');
                  }
            }
      };
        
        if ( startX == 0 && slideDirection == 1 ) {
            $galWrapper.removeClass('sliding');
            return false;
        } else if ( startX == $galWrapperWidth - $slideWidth && slideDirection == -1 ) {
            $galWrapper.removeClass('sliding');
            return false;
        }

      $slide.animate({'marginLeft':endX},500,function() {
            $galWrapper.removeClass('sliding');
      });
});

// POI MAP
$(document).on('click', '.js-poiCategory', function(e) {
      e.preventDefault();
      var category = $(this).attr('data-category');
      if($windowWidth < 901) {
            mobilePOIMap(category);
      }
});

function mobilePOIMap (category) {
      $categoryTitle = $('.map-wrapper aside ul h5');
      $poiListCount = $(document).find('.category.'+category+ ' .category-list li').length;            
      $categoryTitle.removeClass();
      $categoryTitle.html(category.replace(/-/g, " ")).addClass(category);
      if($poiListCount > 5) {
            $('.map-wrapper aside ul').not('category-list').height($poiListCount*47);
      } else {
            $('.map-wrapper aside ul').not('category-list').height($poiListCount*64);
      }
}


$('#js-modelFilter').on('change', function() {

      var val = $(this).val();
      $slide = $galWrapper.find('.gallery-slide');
      $(document).find('.model-listing').each(function() {

            if ( val === "all" || $(this).hasClass(val) ) {
                  $(this).removeClass('off');
            } else {
                  $(this).addClass('off');
            }
      });

      $slide.css('marginLeft', 0+'px');
      additionalModels = $('.gallery-slide .model-listing').not('off');
      additionalModelNav();
      $otherModelsLength = additionalModels.length;
      rightArrow.removeClass('disabled');
      $slide.find('.model-listing').each(function() {
            if ( !$(this).hasClass('off') ) {
                $slideWidth += $(this).width() + parseFloat($(this).css('marginRight'));
            }			
      });
});

slideGallery.scroll(function(){
      scrollDirection = slideGallery.scrollLeft();
      if(scrollDirection > 0) {
              leftArrow.removeClass('disabled');
      } else {
            leftArrow.addClass('disabled');
      }
      
      if(scrollDirection > $slideWidth - $galWrapperWidth) {
            rightArrow.addClass('disabled');
      } else {
            rightArrow.removeClass('disabled');
      }

      if($windowWidth < 768) {
          if (additionalModels.length * slideW - slideW <  scrollDirection) {
              rightArrow.addClass('disabled');
          } else {
              rightArrow.removeClass('disabled');
          }
       }
});

// SCHEDULE A TOUR     
$(document).on('click', '.js-scheduleATour', function() {
      $scheduleATour.addClass('on');
});

$(document).on('click', '.js-scheduleFormClose', function() {
      $(document).find('.scheduleATour').removeClass('on');
});

$(document).on('click', '.js-tour-tip-trig', function() {
      $(document).find('.js-tour-tip').toggleClass('isShowing');
});

$(document).on('click', '.js-click-to-expand', function() {
      $(this).addClass('isHidden');
      $(document).find('.js-expand').addClass('isShowing');
});

$(document).on('click', '#yesAgent', function() {
      $(document).find('.broker-input-field-wrap').removeClass('isHidden');
      $(document).find('#broker_firm').removeAttr('disabled');
});

$(document).on('click', '#noAgent', function() {
      $(document).find('.broker-input-field-wrap').addClass('isHidden');
      $('#broker_firm').prop('disabled', true);
});

$("#scheduleForm input").on("focus", function() {
      $(this).parent().addClass('isFocused');
});

$("#scheduleForm textarea").on("focus", function() {
      $(this).parent().addClass('isFocused');
});

$(document).on('click', '.radioLabel', function() {
      $('input[name="tour_type"]').val($(this).text());
      if($(this).text() == 'Virtual') {
            tourTypeTrack = 'virtual-appointment-complete';
      }
});

let form = document.getElementById("scheduleForm");
let fullName = document.getElementById("fullName");
let firstName = document.getElementById("firstName");
let lastName = document.getElementById("lastName");
function fullNameInput() {
      let length; 
      fullValue = fullName.value;
      fullValue.replace(/^\s*/, "").replace(/\s*$/, "");
      last = "Unspecified";
      temp = fullValue.split(" ");
      length = temp.length;
      if (length > 1) {
            for (var i = 0; i < length; i++) {
                  if (i === 0) {
                  if (temp[i] === "") continue;
                  first = temp[i].replace(/\s*$/, "");
                  } else if (i + 1 < length) {
                  if (temp[i] === "") continue;
                  first = first + " " + temp[i].replace(/\s*$/, "");
                  } else {
                  last = temp[i].replace(/\s*$/, "");
                  }
            }
            } else {
                  first = fullValue;
                  last = "Unspecified";
            }
            firstName.value = first;
            lastName.value = last;


            // if (typeof dataLayer !== "undefined") {
            //       dataLayer.push({ event: "lead_complete" });
            // }
}
// SCHEDULE A TOUR END 


// FORM
function validateForm($form) {
      $form = (typeof $form !== 'undefined') ? $form : $(document).find('form.regForm');
  
      var input, value; 
      var noErrors = true;
  
      // Loop through each required field
      $form.find('.required:visible,input[required]:visible').each(function () {
          input = $(this);
  
          if (!$(this).prop('disabled')) {
  
              // Removes leading & trailing white-space
              value = input.val().replace(/^\s\s*/g, '').replace(/\s\s*$/g, '');
  
              // Validate non radio/checkbox fields
              if (typeof input.attr('type') === 'undefined' || (input.attr('type') !== 'undefined' && (input.attr('type') !== 'radio' && input.attr('type') !== 'checkbox'))) {
                  if (typeof value === "undefined" || value === "") {
                      input.addClass('invalid');
                      noErrors = false;
                  } else {
                      input.removeClass('invalid');
                  }
  
                  // Extra email validation
                  if ((typeof input.attr('type') !== 'undefined' && input.attr('type') === 'email') || input.hasClass('email')) {
                      var filter = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
                      if (!filter.test(value)) {
                          input.addClass('invalid');
                          noErrors = false;
                      } else {
                          input.removeClass('invalid');
                      }
                  }
  
                  // Validate radio/checkbox buttons
              } else {
                  var inputName = input.attr('name');
                  if ($('input[name=' + inputName + ']:checked').length === 0) {
                      noErrors = false;
                  }
              }
          }
      });
  
      return noErrors;
  }

  $(document).on('focus', '.required', function () {
      if (leadInitiated === false && typeof dataLayer !== 'undefined') {
          leadInitiated = true;
          dataLayer.push({'event': "lead_initiated"});
      }
      $(this).removeClass('invalid');
});

  $('form.regForm').submit(function (e) {
      e.preventDefault();
      $activeForm = $(this);
      if($(this).hasClass('scheduleForm')) {
            scheduleForm = true;
            fullNameInput();
      }
     
      if ($activeForm.hasClass('submitting')) {
          return false;
      }
      var validates = validateForm($(this));
      if (validates) {
          $activeForm.addClass('submitting');
          $activeForm.find('.errors').hide();
  
          var myFormData = $activeForm.serialize();
          // GA data for salesforce integration
          if (typeof ga !== "undefined" && typeof ga.getAll === 'function') {
              var gaTracker = ga.getAll()[0];
              var gaClientId = gaTracker.get('clientId');
  
              if (typeof gaClientId !== "undefined") {
                  myFormData = myFormData + "&gaClientId=" + gaClientId;
              }
  
              var gaUserId = gaTracker.get('userId');
              if (typeof gaUserId !== "undefined") {
                  myFormData = myFormData + "&gaUserId=" + gaUserId;
              }
  
              var gaTrackId = gaTracker.get('trackingId');
              if (typeof gaTrackId !== "undefined") {
                  myFormData = myFormData + "&gaTrackId=" + gaTrackId;
              }
          }

          $.ajax({
              url: 'https://go.tollbrothers.com/GenericWebLead/processlead',
              data: myFormData,
              type: 'POST',
              dataType: 'JSONP'

          }).done(function (data) {
              if (data.success === 'true') {
                  // Tracking code...
                  var refNo = data.refNo;
                  // var cridVal = tbiReadCookie('crid');
                  // if ((cridVal != '' && refNo != '') && (cridVal != undefined && refNo != undefined)) {
                  //     var cridPixel = '<div style="display:none;"><img src="https://go.tollbrothers.com/GenericWebLead/conversion.png?crid=' + cridVal + '&refNo=' + refNo + '" alt="convert pixel" /></div>';
                  //     $('body').append(cridPixel);
                  // }
                  //try { dataLayer.push({'event': 'lead_complete'}); } catch(e) { console.log(e.message); }
                  if (typeof dataLayer !== "undefined") {
                    
                        if(scheduleForm) {
                              dataLayer.push({ event: tourTypeTrack });
                        } else {
                              dataLayer.push({ event: "lead_complete" });
                        }
                  }
                  
                  // End tracking code... 
                  if(scheduleForm) {
                        displayScheduleThanks(); 
                  } else {
                        displayThankYou();
                  }
  
                  if (data.callbackUrl) {
                      var iframe = document.createElement('iframe');
                      iframe.setAttribute("style", "position: absolute; top: 10px; left: -1000px;");
                      document.body.appendChild(iframe);
                      iframe.src = data.callbackUrl;
                  }
                  if (typeof _etmc !== 'undefined' && data.email) {
                      _etmc.push(["setOrgId", "7286224"]);
                      _etmc.push(["setUserInfo", {"email": data.email}]);
                      _etmc.push(["trackPageView"]);
                  }
              } else {
                  if(scheduleForm) {
                        displayScheduleUhOh();
                  } else {
                        displayUhOh();
                  }
              }
          }); // end ajax
  
      } else {
            if(scheduleForm) {
                  displayScheduleUhOh();
            } else {
                  displayUhOh();
            }
      }
      return false;
  });
 
  function displayThankYou() {
      
      $(".form-messages .js-thanks-container").show();
      $(".form-messages .js-oops-container").hide();
      $("form.regForm").hide();
      $(".scheduleATour").hide();
      //$('body,html').animate({scrollTop: $(".form-messages .js-thanks-container").offset().top - 200}, 200);
  
      submit_disabled = true;
  }
  
  function displayUhOh() {
      $(".form-messages .js-oops-container").show();
      $(".form-messages .js-thanks-container").hide();
      submit_disabled = true;
  }

  function displayScheduleThanks() {
      $("#scheduleForm").hide();
      $(".scheduleATour .form-bullets").hide();
      $(".scheduleATour .form-heading").html("Thank you!");
      $(".scheduleATour .form-sub-heading").html("We appreciate your interest in Sterling Grove. Our sales team will contact you shortly with more information.");
      submit_disabled = true;
  }
 
  function displayScheduleUhOh() {
      $(".scheduleATour .form-heading").html("Something went wrong.");
      $(".scheduleATour .form-sub-heading").html("Please try again later.");
      submit_disabled = true;
  }